import { render, staticRenderFns } from "./TakePicture.vue?vue&type=template&id=2101d59f&scoped=true&"
import script from "./TakePicture.vue?vue&type=script&lang=ts&"
export * from "./TakePicture.vue?vue&type=script&lang=ts&"
import style0 from "./TakePicture.vue?vue&type=style&index=0&id=2101d59f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2101d59f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
